import { useState } from 'react';

import TextField from '@material-ui/core/TextField';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const NibPasswordInput = ({
  onChange,
  value,
  label = 'Password',
  placeholder = 'password',
  size = 'medium',
  className = {},
  classes = {},
  required = false,
  error = false,
}) => {
  let [localType, setLocalType] = useState('password');
  return (
    <TextField
      onChange={(e) => onChange(e.target.value)}
      required={required}
      error={error}
      value={value}
      label={label}
      type={localType}
      size={size}
      placeholder={placeholder}
      className={className}
      variant="outlined"
      classes={classes}
      InputProps={{
        classes: { root: '!pr-[8px]' },
        endAdornment: (
          <>
            {localType === 'text' ? (
              <VisibilityOffIcon
                style={{ color: '#fff', cursor: 'pointer' }}
                onClick={() => setLocalType(localType === 'text' ? 'password' : 'text')}
              />
            ) : (
              <VisibilityIcon
                style={{ color: '#fff', cursor: 'pointer' }}
                onClick={() => setLocalType(localType === 'text' ? 'password' : 'text')}
              />
            )}
          </>
        ),
      }}
    />
  );
};

export default NibPasswordInput;
